if (!customElements.get("video-player")) {
  customElements.define(
    "video-player",
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();

        this.video = this.querySelector("video");
        this.toggle = this.querySelector(".js-toggle");

        if (!this.video) {
          return;
        }

        if (this.toggle) {
          this.toggle.addEventListener("click", (e) => {
            if (this.video.paused) {
              this.video.play();
            } else {
              this.video.pause();
            }
          });
        }

        this.video.addEventListener("play", () => {
          this.classList.add("playing");
        });
        this.video.addEventListener("pause", () => {
          this.classList.remove("playing");
        });
        this.video.addEventListener("ended", () => {
          this.classList.remove("playing");
        });

        if (this.dataset.autoplay !== undefined) {
          var options = {
            root: null,
            threshold: 0.5,
          };

          var observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.video[entry.isIntersecting ? "play" : "pause"]();
            });
          }, options);

          observer.observe(this);
        }
      }
    }
  );
}
